import React, { Fragment } from 'react';
import RightBar from '../components/account/RightBar';
import EventCenter from '../components/Event/EventCenter';

const E_Event = () => {
    return (
        <Fragment>
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">이벤트</div>
                </div>
            </div>
            <div data-v-623d66c4="" className="event-contents" style={{flexDirection: "row"}}>
                <EventCenter/>
            </div>
        </Fragment>
    );
};

export default E_Event;


// WEBPACK FOOTER //
// ./src/containers/E_Event.js